module.exports = __webpack_public_path__ + "img/icon_palette.961f230.svg";